<template>
  <section class="sme-container ">
    <div class="flex-sb-center">
      <h1>Create Refer Case Ticket</h1>
      <template>
        <div >
          <v-button @click="$router.back()">Back</v-button>
          <v-button
            type="primary"
            @click="handleNext"
          >Next</v-button>
        </div>
      </template>
    </div>
    <span class="table-tab__title">Quick Quote</span>
    <info
      :formData="formData"
      :sme-class-id="class_id"></info>
    <span class="table-tab__title">Kyc</span>
    <sme-kyc-info
      :form-data="formData"
      :show-document="true"
      :class-id="class_id"></sme-kyc-info>
  </section>
</template>

<script>
import info from './sme/component/smeQucikInfo'
import smeKycInfo from '@/views/quoting/sme/component/smeKycInfo'
import {mapState} from 'vuex'
import {addSMEReferTransform, getSMEQuoteDetail} from '@api/sme'

export default {
  name: 'smeReferInformation',
  components:{
    info,
    smeKycInfo
  },
  data(){
    return{
      formData:{}
    }
  },
  computed:{
    ...mapState('account', ['customerId']),
    class_id(){
      return Number(this.$route.query.class_id)
    },
    orderId(){
      return this.$route.query.order_id
    },
  },
  mounted() {
    this.network().getSMEQuoteDetail()
  },
  methods:{
    handleNext(){
      this.network().addSMEReferTransform()
    },
    network() {
      return {
        getSMEQuoteDetail: async () => {
          let {data} = await getSMEQuoteDetail({
            order_id: this.orderId
          },this.class_id)
          this.formData = data
        },
        addSMEReferTransform: async (params = {}) => {
          let {customer,customer_id} = this.formData
          let {contact_title,contact_nm,contact_phone,contact_email} =customer
          // params.contact_us ={
          //   contact_title,
          //   contact_nm,
          //   contact_phone,
          //   contact_email,
          //   customer_id
          // }
          let {data} = await addSMEReferTransform({
            ...this.formData,
            order_id: this.orderId,
            customer_id,
            ...params,
          },this.classId)
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.ticket_id
            }
          })
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.sme-container{
  .mg-b-30{
    margin-bottom: 30px;
  }
  .table-tab__title{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding: 20px 0;
    color: #24292E;
    display: inline-block;
    width: 100%;
  }
  h1{
    font-family: 'SF Pro Display';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 36px;
    color: $dark;
  }
}
</style>
